import React from 'react'
import { checkTranslation } from '../../utils/useful'

class CheckboxInput extends React.Component {
    state = {
    }


    changeInputValue(target) {
        let value = (target.validity.valid) ? target.checked : null
        if (value !== null) {
            this.props.changeValue(this.props.header.key, value)
        }
    }


    render() {
        const label = this.props.header?.information?.label
            ? checkTranslation(this.props.header.information.label)
            : ''
        const checked = Boolean(this.props.data)

        return (
            <div
                className="w-100 h-100"
                style={{
                    padding: '12px 14px',
                    borderRadius: 10,
                    border: '1px solid #e2e8f0',
                    background: checked ? 'rgba(5, 150, 105, 0.06)' : '#f8fafc',
                    transition: 'background 0.2s ease, border-color 0.2s ease',
                }}
            >
                <label className="checkbox-container" style={{ cursor: this.props.header?.information?.disabled ? 'not-allowed' : 'pointer', marginBottom: 0 }}>
                    <input
                        type="checkbox"
                        disabled={Boolean(this.props.header?.information?.disabled)}
                        onChange={(e) => this.changeInputValue(e.target)}
                        checked={checked}
                    />
                    <p className="checkmark"></p>
                    {label ? (
                        <span className="mx-2 text-small" style={{ fontWeight: 600, color: '#0f172a' }}>{label}</span>
                    ) : null}
                </label>
            </div>
        )
    }
}

export default CheckboxInput;